import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { CartProvider } from "./contexts/CartContext";
import ScrollToTop from "./components/ScrollToTop";
import ExitIntentPopup from "./components/ExitIntentPopup";
import BottomNav from "./components/feature/BottomNav";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <CartProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <ScrollToTop />
          <ExitIntentPopup />
          <AppRoutes />
          <BottomNav />
        </BrowserRouter>
      </CartProvider>
    </I18nextProvider>
  );
}

export default App;